var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-3 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/logos", role: "button" }
              },
              [_vm._v("\n              back\n            ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-responsive text-center" }, [
        _vm.pages.length
          ? _c(
              "div",
              { staticClass: "col-4" },
              [
                _c("fg-select", {
                  attrs: { label: "Page", list: _vm.pages, selectedKey: "id" },
                  model: {
                    value: _vm.pageName,
                    callback: function($$v) {
                      _vm.pageName = $$v
                    },
                    expression: "pageName"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c("br"),
        _vm._v(" "),
        _c(
          "table",
          { staticClass: "table table-light table-bordered table-hover" },
          [
            _c(
              "draggable",
              {
                on: {
                  start: function($event) {
                    _vm.drag = true
                  },
                  end: function($event) {
                    _vm.drag = false
                  }
                },
                model: {
                  value: _vm.filteredData,
                  callback: function($$v) {
                    _vm.filteredData = $$v
                  },
                  expression: "filteredData"
                }
              },
              _vm._l(_vm.filteredData, function(item, index) {
                return _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(item.logoId))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.pageName))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.siteNameText))]),
                  _vm._v(" "),
                  _c("td", { staticStyle: { "word-wrap": "break-word" } }, [
                    _vm._v(_vm._s(item.linkDestination))
                  ]),
                  _vm._v(" "),
                  _c("td", { staticStyle: { "word-wrap": "break-word" } }, [
                    _vm._v(_vm._s(item.logoUrl))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("img", {
                      staticClass: "table-thumbnail",
                      attrs: { src: item.logoUrl, alt: "expert-image" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    item.active != "0"
                      ? _c("span", { staticClass: "badge badge-success" }, [
                          _vm._v(" Active ")
                        ])
                      : _c("span", { staticClass: "badge badge-danger" }, [
                          _vm._v(" Inactive ")
                        ])
                  ])
                ])
              }),
              0
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "offset-md-3 col-md-6 text-center" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary btn-fill btn-block",
            on: { click: _vm.updateLogosListing }
          },
          [_vm._v("\n          Update listings order\n        ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Logos - Change Order")]),
      _vm._v(" "),
      _c("p", [_vm._v("You can change list ordering by drag and drop !")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b46d32d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b46d32d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Logos/OrderLogos.vue
// module id = qo/G
// module chunks = 0